import { EventsService } from "@app/services/events.service"
import { PermsService } from "./../services/perms.service"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { ApiService } from "@app/services/api.service"
import { environment } from "@env/environment"
import { LangService } from "@app/services/lang.service"
import {
	Component,
	OnInit,
	ViewChild,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ActivatedRoute, Router, RouterLink } from "@angular/router"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { MenuService } from "@app/services/menu.service"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { MenuContactwaySearchComponent } from "@app/menu-contactway-search/menu-contactway-search.component"
import { ReportsComponent } from "@app/reports/reports.component"
import { ProfitlossComponent } from "@app/profitloss/profitloss.component"
import { TypesCreateComponent } from "@app/types-create/types-create.component"
import { TaxesReportComponent } from "@app/taxes-report/taxes-report.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { SignDocumentsComponent } from "@app/sign-documents/sign-documents.component"
import { DataExportComponent } from "@app/data-export/data-export.component"
import { CreateTakbullAccountComponent } from "@app/create-takbull-account/create-takbull-account.component"
import { CreateGrowAccountComponent } from "@app/create-grow-account/create-grow-account.component"
import { GraphsDataComponent } from "@app/graphs-data/graphs-data.component"
import { ChangePasswordComponent } from "@app/change-password/change-password.component"
import { BkmvdataReportComponent } from "@app/bkmvdata-report/bkmvdata-report.component"
import { SubUserPaymentsComponent } from "@app/sub-user-payments/sub-user-payments.component"
import { Google2faQrCodeComponent } from "@app/google2fa-qr-code/google2fa-qr-code.component"
import { MeetingTimesComponent } from "@app/meeting-times/meeting-times.component"
import { SubUserPatientsComponent } from "@app/sub-user-patients/sub-user-patients.component"
import { InvitePartnerComponent } from "@app/invite-partner/invite-partner.component"
import { FollowupsForSupervisorListComponent } from "@app/followups-for-supervisor-list/followups-for-supervisor-list.component"
import { ItaGetAuthComponent } from "@app/ita-get-auth/ita-get-auth.component"
import { CopyLinkComponent } from "@app/copy-link/copy-link.component"
import { TaskComponent } from "@app/task/task.component"
import { ErrorComponent } from "@app/error/error.component"
import { WalkthroughComponent } from "@app/walkthrough/walkthrough.component"

@Component({
	selector: "app-menu",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenAutocompleteComponent,
		MenuContactwaySearchComponent,
		RouterLink,
		ReportsComponent,
		ProfitlossComponent,
		TypesCreateComponent,
		TaxesReportComponent,
		ModalWrapComponent,
		SignDocumentsComponent,
		DataExportComponent,
		CreateTakbullAccountComponent,
		CreateGrowAccountComponent,
		GraphsDataComponent,
		ChangePasswordComponent,
		BkmvdataReportComponent,
		SubUserPaymentsComponent,
		Google2faQrCodeComponent,
		MeetingTimesComponent,
		SubUserPatientsComponent,
		InvitePartnerComponent,
		FollowupsForSupervisorListComponent,
		ItaGetAuthComponent,
		CopyLinkComponent,
		TaskComponent,
		ErrorComponent,
		WalkthroughComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./menu.component.html",
})
export class MenuComponent implements OnInit {
	modalProps: any = null

	environment = environment
	cliniqData: any = null
	userMenuIsOpen: boolean = false
	notiTotal: number = 0
	@ViewChild("searchFuzzy") searchFuzzy: GenAutocompleteComponent
	isOwner: boolean = false
	showSearchByPhone: string = "no"
	old_debts_report: boolean = false
	enable_israel_invoice: boolean = false
	curMenuItem: string = ""
	isContactwaySearchOpen: boolean = false
	isPatientSearchOpen: boolean = false

	constructor(
		public modalService: ModalService,
		public lang: LangService,
		private router: Router,
		public route: ActivatedRoute,
		private apiService: ApiService,
		public store: StoreService,
		public permsService: PermsService,
		public eventsService: EventsService,
		public menuService: MenuService
	) {}

	async ngOnInit() {
		this.cliniqData = this.store.cc()
		this.isOwner = this.cliniqData.has_users
		this.showSearchByPhone = this.cliniqData.show_search_by_phone
		this.enable_israel_invoice =
			this.cliniqData.enable_israel_invoice == "yes" ? true : false

		this.eventsService.docClickSubject.subscribe((val: any) => {
			if (val?.src !== "userMenu") {
				this.userMenuIsOpen = false
			}
			if (val?.src !== "contactwaySearchIcon") {
				this.isContactwaySearchOpen = false
			}
			if (
				val?.src !== "patientSearchIcon" &&
				!(val?.src instanceof GenAutocompleteComponent)
			) {
				this.isPatientSearchOpen = false
			}
		})

		this.router.events.subscribe((event) => {
			if (this.router?.url) {
				const parts = this.router.url.split("/")
				this.curMenuItem = parts[1]
				if (this.curMenuItem == "home-admin") {
					this.curMenuItem = "home"
				}
			}
		})

		this.route.queryParams.subscribe((params) => {
			if (params?.taskId) {
				this.modalProps = { name: "task", taskId: params.taskId }
			}
		})
		await this.store.timeout(2000)
		this.store.get_task_notifications_total()
	}
	handlePatientSearchIconClick(ev: any) {
		this.isPatientSearchOpen = !this.isPatientSearchOpen
		ev.stopImmediatePropagation()
		this.eventsService.onDocClick({ src: "patientSearchIcon" })
	}
	handleContactwaySearchIconClick(ev: any) {
		this.isContactwaySearchOpen = !this.isContactwaySearchOpen
		ev.stopImmediatePropagation()
		this.eventsService.onDocClick({ src: "contactwaySearchIcon" })
	}

	userMenuOpen(ev: any) {
		this.userMenuIsOpen = !this.userMenuIsOpen
		ev.stopImmediatePropagation()
		this.eventsService.onDocClick({ src: "userMenu" })
	}

	logout() {
		this.apiService.doLogout()
	}
	removeForPerms(arrItems: any[]) {
		for (let item of arrItems) {
			if (item.perms) {
				if (this.permsService.hasMissingPerm(item.perms)) {
					item.hidden = true
				}
			}
			if (item.children) {
				this.removeForPerms(item.children)
			}
		}
	}

	async fuzzyClick(obj: any = null) {
		if (obj && obj.id) {
			this.router.navigateByUrl("/" + obj.typeClassName + "/" + obj.id)
			await this.store.timeout()
			this.searchFuzzy?.emptySearchStr()
		}
	}

	menuItemClick(item: any) {
		if (!item.link && !item.modal && !item.isReportsModal) {
			return
		}

		if (item.isReportsModal) {
			this.modalProps = { name: "reports", report_name: item.report_name }
			return
		}
		if (item.modal) {
			this.modalProps = { name: item?.modal }
			return
		}
		if (item.link === "calendar") {
			const to = `/calendar/${this.store.lastCalView || "week"}/today`
			this.router.navigateByUrl(to)
		} else {
			this.router.navigateByUrl("/" + item.link)
		}
		this.menuService.menu.forEach((it) => {
			if (it.isOpen) {
				it.isOpen = false
			}
			if (it.children) {
				it.children.forEach((it2) => {
					if (it2.isOpen) {
						it2.isOpen = false
					}
					if (it2.children) {
						it2.children.forEach((it3) => {
							if (it3.isOpen) {
								it3.isOpen = false
							}
						})
					}
				})
			}
		})
	}

	openAffiliateLink() {
		this.modalProps = {
			name: "copy-link",
			link: `${location.origin}/regi/regi?affiliate_user_id=${this.store.cc()?.aff_code}`,
		}
	}
}
